// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"08eaf0ac","500":"dc75fffd"}[chunkId] + ".chunk.js";
};